import { ShippingCostProps } from "../lulu/LuluPrintTypes";
import { Serializable } from "../util/Serialization";

export class ShippingCost implements Serializable, ShippingCostProps {

    _className: string = "ShippingCost";
    className: string = "ShippingCost";
    _deserializeClassName: string = "ShippingCost";
    tax_rate!: string;
    total_cost_excl_tax!: string;
    total_cost_incl_tax!: string;
    total_tax!: string;

    constructor(costs : ShippingCostProps){
        if(costs){
            this.tax_rate = costs.tax_rate;
            this.total_cost_excl_tax = costs.total_cost_excl_tax;
            this.total_cost_incl_tax = costs.total_cost_incl_tax;
            this.total_tax = costs.total_tax;
        }
    }
    getIgnoreFields(): string[] {
        return [];
    }
}